module.exports = __webpack_public_path__ + "static/img/s37.4b903214.png";